module.exports = __webpack_public_path__ + "img/kenneth.d3f24b67.jpeg";